<template>
    <div class="pageTitle">
        <h4>MANAGE USERS</h4>
        <p class="pb-0 mb-0">Create and update user account information. Select an account and click on a user below to edit their information, or click Add User to add a new user to the selected account.</p>
    </div>
</template>

<script>
    export default {
        name: 'Home'
    };
</script>
